import { AccountSummaryModelDto } from '@treasury/api/channel';

export const defaultAccountSummaryModelDto: AccountSummaryModelDto = {
    isNew: true,
    showAccountNickName: false,
    number: '',
    type: '',
    name: '',
    currentBalance: 0,
    availableBalance: 0,
    collectedBalance: 0,
};
